import { GENERATION_TOOL } from './const';
import {
  doesToolSupportMixtureModes,
  getToolClassifiedMixtureSubGenerationTools,
  getToolMixtureSubGenerationTools,
} from './toolProps';

const OPTIONS = [
  { subheader: 'Landing page' },
  { tool: GENERATION_TOOL.landingHeadline },
  { tool: GENERATION_TOOL.landingSubheader },
  { tool: GENERATION_TOOL.landingSectionHeadline },
  { tool: GENERATION_TOOL.landingCTA },
  { tool: GENERATION_TOOL.landingBenefits },
  { tool: GENERATION_TOOL.landingFeatures },
  { subheader: 'Website' },
  { tool: GENERATION_TOOL.landingSEOMetaTitle },
  { tool: GENERATION_TOOL.landingSEOMetadata },
  { subheader: 'Blog' },
  { tool: GENERATION_TOOL.articleBlogHeadline },
  { tool: GENERATION_TOOL.blogPostSectionSubHeadline },
  { tool: GENERATION_TOOL.blogPostSectionHeadline },
  { tool: GENERATION_TOOL.blogPostIntroParagraph },
  { subheader: 'Email' },
  { tool: GENERATION_TOOL.emailSubjectLine },
  { tool: GENERATION_TOOL.emailHeadline },
  { tool: GENERATION_TOOL.emailSectionHeadline },
  { tool: GENERATION_TOOL.emailIntroParagraph },
  { tool: GENERATION_TOOL.emailCta },
  { tool: GENERATION_TOOL.emailMixture },
  { subheader: 'Social' },
  { tool: GENERATION_TOOL.instagramCaption },
  { tool: GENERATION_TOOL.facebookPost },
  { tool: GENERATION_TOOL.linkedinPost },
  { tool: GENERATION_TOOL.tweet },
  { tool: GENERATION_TOOL.youtubeTitle },
  { tool: GENERATION_TOOL.youtubeDescription },
  { subheader: 'Ads' },
  { tool: GENERATION_TOOL.facebookMixtureAd },
  { tool: GENERATION_TOOL.twitterMixtureAd },
  { tool: GENERATION_TOOL.googleRSA },
  { tool: GENERATION_TOOL.googleHeadlineProduct },
  { tool: GENERATION_TOOL.googleDescriptionProduct },
  { tool: GENERATION_TOOL.outbrainHeadlineProduct },
  { tool: GENERATION_TOOL.taboolaHeadlineProduct },
  { tool: GENERATION_TOOL.linkedinMixtureAd },
  { tool: GENERATION_TOOL.pinterestMixtureAd },
  { subheader: 'Ecommerce' },
  { tool: GENERATION_TOOL.amazonProductListing },
  { tool: GENERATION_TOOL.walmartProductListing },
  { tool: GENERATION_TOOL.generalProductListing },
  { tool: GENERATION_TOOL.basicProductReview },
  { subheader: 'Other' },
  { tool: GENERATION_TOOL.smsPromotional },
];

const REMOVE_SECTION_HEADLINE_TOOLS = [
  GENERATION_TOOL.blogPostSectionHeadline,
  GENERATION_TOOL.landingSectionHeadline,
  GENERATION_TOOL.emailSectionHeadline,
];

const getToolSubTools = (tool) => {
  const subTools =
    tool === GENERATION_TOOL.emailMixture
      ? getToolClassifiedMixtureSubGenerationTools(tool)
      : getToolMixtureSubGenerationTools(tool);

  return subTools.map((tool) => ({
    tool,
  }));
};

export const getSectionToolsOptions = ({
  withFreeStyle,
  isLongFormProject,
  withoutSubHeaders,
  removeSectionHeadlines,
} = {}) => {
  let filteredOptions = OPTIONS;

  if (removeSectionHeadlines) {
    filteredOptions = filteredOptions.filter(
      (option) => !REMOVE_SECTION_HEADLINE_TOOLS.includes(option.tool)
    );
  }
  if (withFreeStyle) {
    filteredOptions = [
      { subheader: 'General writing' },
      { tool: GENERATION_TOOL.freestyle },
      ...filteredOptions,
    ];
  }

  if (isLongFormProject) {
    filteredOptions = filteredOptions.reduce((result, option) => {
      if (doesToolSupportMixtureModes(option.tool)) {
        const subTools = getToolSubTools(option.tool);
        return [...result, ...subTools];
      }
      if (option.tool === GENERATION_TOOL.googleRSA) {
        return result;
      }

      return [...result, option];
    }, []);
  }

  if (withoutSubHeaders) {
    filteredOptions = filteredOptions.filter((option) => option.tool);
  }

  return filteredOptions;
};
